import React from 'react';
import { FilterBar, FilterReset, FilterSearch, FilterSelect } from '../../ui/FilterBar/FilterBar';
import type { FilterOption } from '../../ui/FilterBar/FilterBar';
import type { AccountStatusFilter, OrganizationFilter, RoleFilter } from '../../../types/access';
import type { AccessOrganization } from '../../../types/access';

const ROLE_OPTIONS: FilterOption<RoleFilter>[] = [
    { value: '', label: 'Все роли' },
    { value: 'user', label: 'Пользователь' },
    { value: 'admin', label: 'Администратор' },
    { value: 'superadmin', label: 'Суперадминистратор' },
];

interface UsersFiltersProps {
    organizations: AccessOrganization[];
    query: string;
    role: RoleFilter;
    organization: OrganizationFilter;
    status: AccountStatusFilter;
    isFiltered: boolean;
    onQueryChange: (value: string) => void;
    onRoleChange: (value: RoleFilter) => void;
    onOrganizationChange: (value: OrganizationFilter) => void;
    onStatusChange: (value: AccountStatusFilter) => void;
    onReset: () => void;
}

export function UsersFilters({
    organizations,
    query,
    role,
    organization,
    status,
    isFiltered,
    onQueryChange,
    onRoleChange,
    onOrganizationChange,
    onStatusChange,
    onReset,
}: UsersFiltersProps) {
    const organizationOptions: FilterOption<OrganizationFilter>[] = [
        { value: '', label: 'Все организации' },
        ...organizations.map((item) => ({ value: item.id as OrganizationFilter, label: item.name })),
    ];

    return (
        <FilterBar>
            <FilterSearch
                value={query}
                placeholder="Поиск по имени или почте"
                label="Поиск по пользователям"
                onChange={onQueryChange}
            />

            <FilterReset active={isFiltered} onClick={onReset} />

            <FilterSelect options={ROLE_OPTIONS} value={role} allValue="" onChange={onRoleChange} />

            <FilterSelect
                options={organizationOptions}
                value={organization}
                allValue=""
                onChange={onOrganizationChange}
                wide
                align="right"
                searchable
                searchPlaceholder="Название организации"
            />
        </FilterBar>
    );
}